import React, { ReactElement } from "react";
import CategoriesList from "./categories-list";
import FaqList from "./faq-list";
import { IAccordionItem } from "../../../genericTypes/sharedTypes";
import { GQLCategories } from "@gql/types/gql";

export default function Accordion({
    items,
    className,
    type = "faq",
}: {
    items: IAccordionItem[] | (GQLCategories | null)[] | null | undefined;
    className?: string;
    type?: "categories" | "blog" | "faq";
}): ReactElement {
    if (type === "categories") {
        return (
            <CategoriesList
                items={items as GQLCategories[]}
                className={className}
            />
        );
    }
    if (type === "blog") {
        return (
            <FaqList items={items as IAccordionItem[]} className={className} />
        );
    }
    if (type === "faq") {
        return (
            <FaqList
                items={items as IAccordionItem[]}
                className={className}
                faq={true}
            />
        );
    }
    return <FaqList items={items as IAccordionItem[]} className={className} />;
}
